import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { MobileSidebar } from './MobileSidebar'
import { ImpersonationBanner, useImpersonationOffset } from './ImpersonationBanner'

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const hasOffset = useImpersonationOffset()

  return (
    <div className="min-h-screen bg-muted/40">
      {/* Impersonation banner — fixed at very top */}
      <ImpersonationBanner />

      {/* Spacer to push everything below the fixed banner */}
      {hasOffset && <div className="h-10" />}

      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Mobile Sidebar */}
      <MobileSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="lg:pl-64">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
